import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.powder,
  borderColor: colors.overcast,
  linkColor: colors.dirtBrown
};
export default jumplink;